class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

document.addEventListener('focusin', (e) => {
  const t = e.target;
  if (!t) return;

  const isCouponInput =
    t.matches('#halo-cart-sidebar input[name="discount"], #halo-cart-sidebar input[name*="coupon"]');

  if (!isCouponInput) return;

  const popup = t.closest('#popup-tool-discount');
  const popupOpen = popup && popup.classList.contains('show');

  if (!popupOpen) {
    t.blur();
    e.preventDefault();
  }
}, true);


/* ===== COUPON: click robusto anche dopo updateSidebarCart ===== */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('#halo-cart-sidebar [data-update-coupon]');
  if (!btn) return;

  e.preventDefault();

  const scope =
    btn.closest('#popup-tool-discount') ||
    btn.closest('cart-coupon-discount') ||
    document;

  const input =
    scope.querySelector('input[name="discount"]') ||
    document.querySelector('#halo-cart-sidebar input[name="discount"]');

  const val = (input?.value || '').trim();
  if (!val) return;

  localStorage.setItem('storedDiscount', val);

  fetch(`/discount/${encodeURIComponent(val)}`)
    .then(r => r.text())
    .then(() => Shopify.getCart((cart) => window.sharedFunctions?.updateSidebarCart(cart)))
    .finally(() => {
      document.querySelectorAll('#halo-cart-sidebar .popup-toolDown.show')
        .forEach(p => p.classList.remove('show'));
      document.querySelector('#halo-cart-sidebar .previewCart')
        ?.classList.remove('active-tool');
      input?.blur();
      document.activeElement?.blur();
    });
});
